import { makeGoalCalculator } from "./makeGoalCalculator";

/**
 * Generic named goal — replaces the earlier Goal Calculator, adding a current-savings offset and
 * keeping the profile saved-goal picker (goalPicker) so a member can auto-fill from a goal saved
 * on their profile.
 */
export default makeGoalCalculator({
  key: "custom-goal",
  title: "Custom Goal",
  description: "Turn any life goal into today's numbers: what it will cost, and the monthly SIP to reach it.",
  goalNameField: true,
  goalPicker: true,
  labels: {
    presentCost: "Cost of goal today",
    years: "Years to achieve goal",
    currentSavings: "Current savings for goal",
  },
  defaults: { goalName: "Child's education", presentCost: 20_00_000, yearsToGoal: 12 },
});
